const Types = {
  REQUEST: "haux/auth/REQUEST",
  REQUEST_SUCCESS: "haux/auth/REQUEST_SUCCESS",
  REQUEST_FAIL: "haux/auth/REQUEST_FAIL",
  LOGOUT: "haux/auth/LOGOUT",
};

export default Types;
